import {Routes} from '@angular/router';
import {NgxPermissionsGuard} from 'ngx-permissions';
import {permissions} from '../../permissions';
import {AuthGuardService as AuthGuard} from '../../auth-guard.service';
import {TeamworkReportsComponent} from './teamwork-reports.component';
import {CompanyMappingComponent} from './company-mapping/company-mapping.component';
import TicketsRepliesCols from './tickets-replies/tickets-replies.cols';
import {TicketsRepliesComponent} from './tickets-replies/tickets-replies.component';

export const routes: Routes = [{
  path: 'teamwork-reports',
  component: TeamworkReportsComponent,
  canActivate: [AuthGuard, NgxPermissionsGuard],
  data: {
    title: 'Teamwork Reports',
    permissions: {
      only: []
    }
  },
}, {
    path: 'teamwork-reports/tickets-replies',
    component: TicketsRepliesComponent,
    canActivate: [AuthGuard, NgxPermissionsGuard],
    data: {
        title: 'Teamwork Tickets Replies',
        permissions: {
            only: []
        }
    },
}, {
  path: 'teamwork-reports/company-mapping',
  component: CompanyMappingComponent,
  canActivate: [AuthGuard, NgxPermissionsGuard],
  data: {
    title: 'Teamwork Company Mapping',
    permissions: {
      only: []
    }
  },
}];



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/views/teamwork-reports/teamwork-reports.routing.ts